/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { ServizioMensaMenuDTO } from '../model/servizio-mensa-menu-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    MenuCittadinoServiceInterface,
    DownloadMenuCittadinoRequestParams,
    ListMenuCittadinoRequestParams
} from './menu-cittadino.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class MenuCittadinoService extends BaseService implements MenuCittadinoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Scarica il file di un menu visibile per uno studente del cittadino.
     * Audience CITTADINO. Scarica da S3 il file del menu indicato, ammesso solo se rientra tra i menu visibili per lo studente (ORDINARIO del servizio dello studente oppure EXTRA assegnato): lo stesso insieme della lista. Servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (gate Pratica-accettata) + owner-check per-studente. Menu non visibile (di altro studente/servizio o inesistente) → 404 privacy-preserving.
     * @endpoint get /api/v1/cittadino/servizi/mensa/menu/{id_menu}/download
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public downloadMenuCittadino(requestParameters: DownloadMenuCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Blob>;
    public downloadMenuCittadino(requestParameters: DownloadMenuCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Blob>>;
    public downloadMenuCittadino(requestParameters: DownloadMenuCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Blob>>;
    public downloadMenuCittadino(requestParameters: DownloadMenuCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/octet-stream' | 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idMenu = requestParameters?.idMenu;
        if (idMenu === null || idMenu === undefined) {
            throw new Error('Required parameter idMenu was null or undefined when calling downloadMenuCittadino.');
        }
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling downloadMenuCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling downloadMenuCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_studente',
            <any>idStudente,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/octet-stream',
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let localVarPath = `/api/v1/cittadino/servizi/mensa/menu/${this.configuration.encodeParam({name: "idMenu", value: idMenu, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/download`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: "blob",
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Lista dei menu visibili per uno studente del cittadino.
     * Audience CITTADINO. Ritorna il menu ORDINARIO del servizio dello studente indicato + l\&#39;eventuale menu EXTRA assegnato allo studente. Servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id (gate Pratica-accettata) + owner-check per-studente.
     * @endpoint get /api/v1/cittadino/servizi/mensa/menu
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listMenuCittadino(requestParameters: ListMenuCittadinoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<ServizioMensaMenuDTO>>;
    public listMenuCittadino(requestParameters: ListMenuCittadinoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ServizioMensaMenuDTO>>>;
    public listMenuCittadino(requestParameters: ListMenuCittadinoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ServizioMensaMenuDTO>>>;
    public listMenuCittadino(requestParameters: ListMenuCittadinoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idStudente = requestParameters?.idStudente;
        if (idStudente === null || idStudente === undefined) {
            throw new Error('Required parameter idStudente was null or undefined when calling listMenuCittadino.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listMenuCittadino.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'id_studente',
            <any>idStudente,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/cittadino/servizi/mensa/menu`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<ServizioMensaMenuDTO>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
